
(function (){ 
	'use strict';

	$( document ).ready(function() {
		try{
		if (dojo.byId('checkoutHeaderIdForJS')) {
			return;
		}

		initializeOnBehalfOf();
		initializeCartCounts();
		initializeCartRemovedItem();

					}catch (e) {
			   console.log(e); 
			}

			});

		function getCookieBoolean(cookieName) {
		var cookieVal = dojo.cookie(cookieName);
		if (!cookieVal || cookieVal == 'false') {
			return false;
		}
		else {
			return true;
		}
	}

		function initializeOnBehalfOf() {
		var oboSessionBegan = getCookieBoolean('obocookie');

			if (oboSessionBegan && document.getElementById('oboRegisterLink') != null && document.getElementById('signOutLinkButton') != null ) {
			document.getElementById('oboRegisterLink').style.display = 'none';
			document.getElementById('signOutLinkButton').style.display = 'none';
		}
		else if (document.getElementById('oboRegisterLink') != null && document.getElementById('signOutLinkButton') != null) {
			document.getElementById('oboRegisterLink').style.display = 'inline';
			document.getElementById('signOutLinkButton').style.display = 'none';
		}
	}


		function initializeCartCounts() {
		var CartId = dojo.cookie('WC_CartOrderId_'.concat(WCParamJS.storeId));
		var cartTotalCookie = dojo.cookie('rCartTotal');
		if (cartTotalCookie != null && cartTotalCookie != undefined && cartTotalCookie != '0') {
			if (document.getElementById('cart-count')) {
				document.getElementById('cart-count').innerHTML = cartTotalCookie;
			}
			if (document.getElementById('persistent-cart-count')) {
				document.getElementById('persistent-cart-count').innerHTML = cartTotalCookie;
			}
			if (document.getElementById('mobile-cart-count')) {
				document.getElementById('mobile-cart-count').innerHTML = cartTotalCookie;
			}
		}
	}

	function initializeCartRemovedItem() {
		if(document.getElementById('RemovedCartCheck') != null ){
			document.getElementById('RemovedCartCheck').value = 'No';
		}

				if(document.getElementById('RemovedOrdCount') != null){
			var rmvOrdCount = document.getElementById('RemovedOrdCount').value;

						if (document.getElementById('removeCartUndo_' + rmvOrdCount)) {
			   document.getElementById('removeCartUndo_' + rmvOrdCount).innerHTML = ' ';
			}
			else if (document.getElementById('removeCartUndo')) { 
				document.getElementById('removeCartUndo').innerHTML = ' ';
			}
		}


						if (document.getElementById('removeCartUndo_last')) {
			document.getElementById('removeCartUndo_last').innerHTML = ' ';
		}
		if(document.getElementById('UndoValue') != null){
			document.getElementById('UndoValue').value ='No';
		}
		if(document.getElementById('RDScheduleFrqValue') != null){
			document.getElementById('RDScheduleFrqValue').value = '';
		}
		if(document.getElementById('removedAttrNames') != null){
			document.getElementById('removedAttrNames').value = '';
		}
		if(document.getElementById('removedAttrvalue') != null){
			document.getElementById('removedAttrvalue').value = '';
		}
		if(document.getElementById('RemovedDonation') != null){
			document.getElementById('RemovedDonation').value = '';
		}
	}
})();



function setUserTypeCookie(userType) {
	'use strict';
	var cookieAlreadyExists = dojo.cookie('WC_UserType');
	var newCookieValue = (cookieAlreadyExists && userType != 'G') ? 'R' : 'G';
	dojo.cookie('WC_UserType', newCookieValue, {path:'/'});
	var domain = "";
	if(dojo.byId('cookieDomain') != null){
		domain = dojo.byId('cookieDomain').value;
	}
	dojo.cookie("rUserType", newCookieValue, {path:'/',domain:domain});
}

function getUserTypeCookie() {
	'use strict';
	return dojo.cookie('rUserType');
}
